var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "389DA265-FA3C-4C85-BD5A-1A65091B3163") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1141.000000, -187.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(1141.931831, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.34375 L8,8.34375 L0,0.34375 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,0.34375 L15,8.34375 L7,0.34375 Z",
    id: "Path-2",
    transform: "translate(11.000000, 4.343750) scale(-1, 1) translate(-11.000000, -4.343750) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.34375 L8,15.34375 L0,7.34375 Z",
    id: "Path-2",
    transform: "translate(4.000000, 11.343750) scale(1, -1) translate(-4.000000, -11.343750) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,7.34375 L15,15.34375 L7,7.34375 Z",
    id: "Path-2",
    transform: "translate(11.000000, 11.343750) scale(-1, -1) translate(-11.000000, -11.343750) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCancel);
export default __webpack_public_path__ + "static/media/ico_cancel.5fe8920b062c1f042fdc870d8df70a8e.svg";
export { ForwardRef as ReactComponent };